const { useRef, useEffect, useState } = require("react");
const { compareArrays } = require('../utils/detectObjectChanges');

function usePaymentMethodDiscountWatcher({
  paymentMethods,
  callback,
  pathsToWatch = ['discount']
}) {
  const initialPaymentMethods = useRef(paymentMethods);
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    if (initialPaymentMethods.current === undefined) return;
    const compared = compareArrays(initialPaymentMethods.current, paymentMethods);

    if (!compared.length) {
      return;
    }

    const relevantChange = compared.find(
      c => pathsToWatch.some(path => c.path.endsWith(path))
    );

    if (relevantChange) {
      callback?.(paymentMethods[relevantChange.index]);
      setHasChanged(true);
      initialPaymentMethods.current = paymentMethods;
    } else {
      setHasChanged(false);
    }
  }, [paymentMethods]);

  return hasChanged;
}

module.exports = usePaymentMethodDiscountWatcher;